/*
 * WaWiGruppenAppQueries.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-02 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import gql from 'graphql-tag';

import { GRUPPE_FRAGMENT, RESERVIERUNGSPOSITION_FRAGMENT, RESERVIERUNG_FRAGMENT } from '../fragments';

export const GRUPPEAKTIV_LIST_QUERY = gql`
  query AktiveGruppen($cursor: String) {
    nodes: hwKundenGruppePages(
      after: $cursor
      filter: { ist_aktiv: { eq: true } }
      sort: { order: DESC, fields: updated_at }
    ) {
      edges {
        # cursor
        node {
          ...gruppeFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${GRUPPE_FRAGMENT}
`;

export const RESERVIERUNG_LIST_QUERY = gql`
  query GruppenReservierungen($nr: ID!) {
    entity: hwKundenGruppe(designator: $nr) {
      nodes: reservierungen(filter: { erledigt: { eq: false } }) {
        ...reservierungFragment
      }
    }
  }
  ${RESERVIERUNG_FRAGMENT}
`;

export const RESERVIERUNGSPOS_LIST_QUERY = gql`
  query GruppenReservierungsPositionen($nr: ID!) {
    entity: hwKundenGruppe(designator: $nr) {
      reservierungen(filter: { erledigt: { eq: false } }) {
        nodes: positionen {
          ...resevierungspositionFragment
          item {
            id
            name
            produkt {
              id
              designator
              kategorie
              einheit
            }
            zukunft {
              id
              freie_menge
              frei_ab
              buchbestand
              zukuenftiger_zulauf
              naechster_zulauf
              zukuenftiger_ablauf
              naechster_ablauf
            }
            preisResolved {
              uvp
              fh
              id
              designator
              basis_name
              bartnr
            }
          }
        }
      }
    }
  }
  ${RESERVIERUNGSPOSITION_FRAGMENT}
`;

export const GRUPPEN_MITGLIEDER_RESERVIERUNGSPOS_QUERY = gql`
  query GruppeMitgliederReservierungenQuery($nr: ID!) {
    entity: hwKundenGruppe(designator: $nr) {
      id
      nodes: kunden {
        designator
      }
    }
  }
`;
